import React, { Component } from 'react';
import { Table, Form, Row, Col, Input, Button, Section, Icon, Collapsible, CollapsibleItem } from 'react-materialize';
import Instance from './Instance';
import './Instances.css';
import AuthManager from './AuthManager';

class History extends Component {
    constructor(props) {
        super();
        this.state = {
            msgs: []
        };  
        this.Papa = require("papaparse/papaparse.min.js");  
    }

    componentWillMount() {
        var authManager = new AuthManager();
        authManager.getCreds((function(err) {
            if (!err) {
                this.apigClient = window.apigClientFactory.newClient();
                this.authToken = authManager.getIdToken();
                this.listMsgs();
            }   
        }).bind(this));
    }

    listMsgs() {
        var params = {};
        var body = {};
        var additionalParams = {
            headers: {Authorization: this.authToken.getJwtToken()},
            queryParams: {}
        };
        this.apigClient.getresultsGet(params, body, additionalParams)
            .then((function (result) {
                try {
                    var msgs = JSON.parse(result.data.msgs)
                    this.setState({
                        msgs: msgs
                    });
                } catch (ex) {
                    console.log("RESULT PARSE ERR: ", ex.msg);
                }
                
            }).bind(this)).catch(function (err) {
                console.log("GetResults Error: " + JSON.stringify(err));
            });
    }

    downloadFile(msgID) {
        var msg = this.state.msgs[msgID];
        var csvString = this.Papa.unparse({
        	fields: msg.radii,
        	data: msg.rows
        });
        var blob = new Blob([csvString]);
        if (window.navigator.msSaveOrOpenBlob)  // IE hack; see http://msdn.microsoft.com/en-us/library/ie/hh779016.aspx
            window.navigator.msSaveBlob(blob, msgID + ".csv");
        else
        {
            var a = window.document.createElement("a");
            a.href = window.URL.createObjectURL(blob, {type: "text/plain"});
            a.download = msgID + ".csv";
            document.body.appendChild(a);
            a.click();  // IE: "Access is denied"; see: https://connect.microsoft.com/IE/feedback/details/797361/ie-10-treats-blob-url-as-cross-origin-and-denies-access
            document.body.removeChild(a);
        }
    }

    render() {
        let msgArr = [];
        console.log(typeof(this.state.msgs));
        console.log(JSON.stringify(this.state.msgs));
        for (var msgID in this.state.msgs) {
            var msg = this.state.msgs[msgID];
            var radiiElms = [];
            for (var radius of msg.radii) {
                radiiElms.push(<th>{radius}</th>);
            }
            var rowElms = [];
            for (var row of msg.rows) {
                var cols = [];
                for (var c of row) {
                    cols.push(<td>{c}</td>);
                }
                rowElms.push(<tr>{cols}</tr>);
            }
            msgArr.push(<CollapsibleItem header={msgID} onSelect={()=>{}}>
            <Table>
                <thead>
                    <tr>
                        {radiiElms}
                    </tr>
                </thead>
                <tbody>
                    {rowElms}
                </tbody>
            </Table>
            <Button onClick={this.downloadFile.bind(this, msgID)}>Download CSV</Button></CollapsibleItem>);
        }
        
        return (
            <div class="card-panel grey lighten-5 z-depth-1">
                <Section>
                    <Row>
                        <Col offset={"s1"} s={4}>
                            <h3 s={12}><Icon small>computer</Icon>Results</h3>
                        </Col>
                    </Row>
                    <Row>
                        <Col s={12}>
                            <Collapsible s={12}>
                                {msgArr}
                            </Collapsible>
                        </Col>
                    </Row>
                </Section>
                <Row>
                    <Button waves='light' s={2} onClick={(this.listMsgs).bind(this)}><Icon>refresh</Icon></Button>
                </Row>
            </div>
        );
    }
}

export default History;



// WEBPACK FOOTER //
// ./src/History.js